export default __webpack_public_path__ + "static/media/Upload-rafiki.33def22b.svg";